import Icons from 'iconSprites/IconSprite.svg';

type IconT = {
  name: string;
  color?: string;
  fillOpacity?: string;
  size?: string;
  width?: string;
  height?: string;
  className?: string;
  onClick?: () => void;
};

export const Icon = ({ name, color, size, width, height, className, onClick, fillOpacity }: IconT) => {
  return (
    <svg
      onClick={onClick}
      className={className}
      color={color}
      fill={color}
      width={width || size || '24px'}
      height={height || size || '24px'}
      fillOpacity={fillOpacity}
      strokeOpacity={fillOpacity}
      cursor={onClick ? 'pointer' : 'normal'}
    >
      <use xlinkHref={`${Icons}#icon-${name}`} />
    </svg>
  );
};
